/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState, useRef } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import Swal from 'sweetalert2';

// @mui material components
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Alert from '@mui/material/Alert';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import InputAdornment from '@mui/material/InputAdornment';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDSnackbar from 'components/MDSnackbar';
import MDInput from 'components/MDInput';
import TableHeader from 'components/Table/TableHeader';
import MDSelect from 'components/MDSelect';
import MDTypography from 'components/MDTypography';
import MDBadge from 'components/MDBadge';
import MDDatePicker from 'components/MDDatePicker';
import MDDateRange from 'components/MDDateRange';
import TabPanel from 'components/TabPanel/TabPanel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Navbar from 'examples/Navbars/NavBar';
import Footer from 'examples/Footer';
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import { useSelector } from 'react-redux';
import * as Func from 'services/Function';
import stepperName from './CountingStatus';
import CountingList from './CountingList';
import CountingStepper from './CountingStepper';

const initAttr = {
  id: '',
  code: '',
  remark: '',
  request_id: '',
  warehouse_id: '',
  status: 'edit',
  print_url: '',
  created_at: '',
  updated_at: '',
  print: '',
  print_no: '',
  counting_all: 'Y',
  date_start: Func.dateNow(),
  date_stop: Func.dateNow(),
};

const initRequest = {
  id: '',
  code: '',
  remark: '',
  warehouse_id: '',
  warehouse_name: '',
  time_name: '',
  time_id: '',
  status: 'edit',
  print_url: '',
  created_at: '',
  updated_at: '',
  print: '',
  print_no: '',
  counting_all: 'N',
  approve_auto: 'Y',
  date_start: '',
  date_stop: '',
};

const initFind = {
  search: '',
  order_by: 'tb.code',
  order_sort: 'desc',
  page: 1,
  perPage: 10,
  pageTotal: 0,
  status: 'ALL',
  period: 'ALL',
  warehouse: 'ALL',
  date_start: Func.dateTimeFirstMonth(),
  date_stop: Func.dateTimeEndMonth(),
};

const initNavigate = {
  first: '',
  prev: '',
  next: '',
  last: '',
};

const cboStatus = [
  { id: 'ALL', name: 'ทั้งหมด' },
  { id: 'edit', name: stepperName.edit.name },
  { id: 'request', name: stepperName.request.name },
  { id: 'approve', name: stepperName.approve.name },
  { id: 'success', name: stepperName.success.name },
  { id: 'cancel', name: stepperName.cancel.name },
];

function Counting() {
  const mod = 'counting';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [show, setShow] = useState(null);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [navigate, setNavigate] = useState(initNavigate);
  const [notify, setNotify] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [modalAdd, setModalAdd] = useState(false);
  const [stepper, setStepper] = useState({});
  const [tab, setTab] = useState(0);
  const [image, setImage] = useState([]);
  const [photo, setPhoto] = useState({});
  const [request, setRequest] = useState(initRequest);
  const [modalPhoto, setModalPhoto] = useState(false);
  const [cboRequest, setCboRequest] = useState([]);
  const [cboWarehouse, setCboWarehouse] = useState([]);
  const listRef = useRef();

  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);

  const initHeader = [
    { id: 'tb.id', label: t(`attr.image`), align: 'center', width: 40 },
    { id: 'tb.status', label: 'สถานะ', align: 'center' },
    { id: 'tb.code', label: t(`attr.code`), align: 'center' },
    { id: 'tb.request_id', label: 'ใบสั่งนับ', align: 'left' },
    { id: 'tb.branch_id', label: 'สาขาตรวจนับ', align: 'left' },
    { id: 'tb.warehouse_id', label: 'คลังที่ตรวจนับ', align: 'left' },
    { id: 'tb.user_id', label: 'ผู้นับ', align: 'left' },
    { id: 'tb.date_start', label: 'เริ่มนับ', align: 'center' },
    { id: 'tb.date_stop', label: 'นับเสร็จ', align: 'center' },
  ];

  const showNotify = (msg, color) => {
    setNotify(
      <MDSnackbar
        color={color}
        icon='notifications'
        title={t(`app.name`)}
        content={msg}
        dateTime={Func.dateTimeDisplay()}
        open={Boolean(true)}
        close={() => setNotify(!notify)}
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);
    setRecord([]);
    closeShow();

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
      status: data.status,
      period: data.period,
      date_start: data.date_start,
      date_stop: data.date_stop,
      warehouse: data.warehouse,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const open = () => {
    setLoading(true);
    setConfirm(false);
    setAttr(initAttr);
    setTab(0);

    FetchData('GET', `/${mod}/${id}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setAttr(result.data);
        setNavigate(result.navigate);
        setStepper(result.stepper);
        setImage(result.image);
        setRequest(result.request);

        setLoading(false);
      }
    });
  };

  const setDateRange = (start, stop) => {
    view({
      ...find,
      date_start: Func.dateTimeFormat(start.toDate()),
      date_stop: Func.dateTimeFormat(stop.toDate()),
      page: 1,
    });
  };

  const addConfirm = () => {
    if (!Func.verifyLength(attr.request_id, 1)) return;

    setConfirm(true);
  };

  const add = () => {
    setLoading(true);
    setModalAdd(false);
    setConfirm(false);

    FetchData('PUT', `/${mod}`, app.token, {
      remark: attr.remark,
      request_id: attr.request_id,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        window.location.replace(`/${mod}/${result.id}`);
        showNotify(t(`alert.addcomplete`), 'success');
      } else {
        setModalAdd(true);
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const copy = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData('OPTIONS', `/${mod}/copy`, app.token, {
          id: id,
        }).then((result) => {
          if (result.status === 'ok') {
            window.location.replace(`/${mod}/${result.id}`);
            showNotify(t(`alert.addcomplete`), 'success');
          } else {
            setLoading(false);
            showNotify(t(`alert.saveerror`), 'error');
          }
        });
      }
    });
  };

  const edit = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
          remark: attr.remark,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            showNotify(t(`alert.${result.msg}`), 'error');
          }
        });
      }
    });
  };

  const approve = (status) => {
    Swal.fire({
      title: `คุณต้องการเปลี่ยนสถานะเป็น \n"${stepperName[status].name}" ใช่หรือไม่ ?`,
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off',
        placeholder: 'หมายเหตุ',
      },
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        const remark = Swal.getInput()?.value || '';
        if (status === 'cancel' && remark === '') {
          showNotify('กรุณากรอกหมายเหตุ', 'error');
          return;
        }

        setLoading(true);
        FetchData('OPTIONS', `/${mod}/approve`, app.token, {
          id: id,
          status: status,
          remark: remark,
        }).then((result) => {
          if (result.status === 'ok') {
            open();
            listRef.current.refresh();
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            setLoading(false);
            showNotify(result.msg, 'error');
          }
        });
      }
    });
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t(`element.show_record`, { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t(`element.show_record`, { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t(`element.show_record`, { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? 'desc' : 'asc' });
  };

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setAttr(initAttr);
        setCboRequest(result.request);
        setCboWarehouse(result.warehouse);

        if (id === undefined) {
          view(find);
        } else {
          open();
        }
      } else {
        Func.exitApp();
      }
    });
  };

  const btnOpen = (item) => {
    return (
      <NavLink to={`/${mod}/${item.id}`}>
        <MDButton
          variant='text'
          color='info'
          size='small'
          sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}
        >
          {item.code}
        </MDButton>
      </NavLink>
    );
  };

  const statusDisplay = (item) => {
    return (
      <Alert
        icon={<Icon>{stepperName[item.status].icon}</Icon>}
        severity={stepperName[item.status].color}
        sx={{
          fontSize: '14px',
          padding: '0 10px',
          fontWeight: 400,
          borderRadius: 5,
          whiteSpace: 'nowrap',
        }}
      >
        {stepperName[item.status].name}
      </Alert>
    );
  };

  const renderSearch = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDBox
              noValidate
              component='form'
              role='form'
              onSubmit={(e) => {
                e.preventDefault();
                view({ ...find, period: 'ALL', page: 1 });
              }}
            >
              <MDInput
                name='searchform'
                fullWidth
                value={find.search}
                type='search'
                onChange={(e) => setFind({ ...find, search: e.target.value, page: 1 })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>{t('element.search')} :</InputAdornment>
                  ),
                  autoComplete: 'off',
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <MDInput
              fullWidth
              value={find.warehouse}
              defaultValue='ALL'
              select
              onChange={(e) => view({ ...find, warehouse: e.target.value, page: 1 })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>{t('menu.warehouse')} :</InputAdornment>
                ),
              }}
            >
              <MenuItem value='ALL'>{t('element.show_all')}</MenuItem>
              {cboWarehouse.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </MDInput>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDInput
              fullWidth
              value={find.status}
              defaultValue='ALL'
              select
              onChange={(e) => view({ ...find, status: e.target.value, page: 1 })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <span>สถานะ :</span>
                  </InputAdornment>
                ),
              }}
            >
              {cboStatus.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </MDInput>
          </Grid>
          {find.period === 'ALL' ? (
            <Grid item xs={12} sm={12} md={6} lg={2}>
              <MDButton
                variant='outlined'
                color='secondary'
                fullWidth
                sx={{ p: 1.5 }}
                onClick={() => view({ ...find, period: 'DATE', page: 1 })}
              >
                <Icon>edit_calendar</Icon>&nbsp;เลือกช่วงเวลา
              </MDButton>
            </Grid>
          ) : null}
          {find.period === 'ALL' ? null : (
            <Grid item xs={12} sm={12} md={12} lg={7}>
              <MDDateRange
                dateStart={find.date_start}
                dateStop={find.date_stop}
                callBack={setDateRange}
                closeDate={() => view({ ...find, period: 'ALL', page: 1 })}
              />
            </Grid>
          )}
        </Grid>
      </Card>
    );
  };

  const renderList = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={9} md={10} lg={11}>
            {renderSearch()}
          </Grid>
          <Grid item xs={12} sm={3} md={2} lg={1}>
            <MDButton
              variant='contained'
              color='dark'
              size='large'
              fullWidth
              sx={{ pt: 1.6, pb: 1.6 }}
              onClick={() => {
                setAttr(initAttr);
                setConfirm(false);
                setModalAdd(true);
              }}
            >
              <Icon>post_add</Icon>
            </MDButton>
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ minHeight: 400 }}>
              <Table aria-label='datatable table'>
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell
                        onClick={() => {
                          setPhoto(row);
                          setModalPhoto(true);
                        }}
                      >
                        {Func.imageDisplay(row)}
                      </TableCell>
                      <TableCell align='center' width={160}>
                        {statusDisplay(row)}
                      </TableCell>
                      <TableCell align='center'>{btnOpen(row)}</TableCell>
                      <TableCell align='left' className='nowrap'>
                        {row.request_code}
                      </TableCell>
                      <TableCell align='left' className='nowrap'>
                        {row.branch_code}
                      </TableCell>
                      <TableCell align='left' className='nowrap'>
                        {row.warehouse_name}
                      </TableCell>
                      <TableCell align='left'>{row.user_name}</TableCell>
                      <TableCell align='center' className='nowrap'>
                        {Func.dateTimeDisplay(row.date_start)}
                      </TableCell>
                      <TableCell align='center' className='nowrap'>
                        {Func.dateTimeDisplay(row.date_stop)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox display='flex' justifyContent='space-between' alignItems='flex-start'>
                <MDButton variant={show ? 'contained' : 'outlined'} color='dark' onClick={openShow}>
                  {t(`element.show_record`, { num: find.perPage })}&nbsp;
                  <Icon>keyboard_arrow_down</Icon>
                </MDButton>
                {renderShow}
                <Pagination
                  count={pageTotal}
                  variant='outlined'
                  color='secondary'
                  showFirstButton
                  showLastButton
                  page={pageNo}
                  onChange={(e, p) => view({ ...find, page: p })}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderInfo = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MDSelect
            label='รอบการตรวจนับ *'
            labelDefault={t(`element.please_select`)}
            data={cboRequest}
            value={attr.request_id}
            onChange={(e) => setAttr({ ...attr, request_id: e.target.value })}
            inputProps={{
              autoComplete: 'off',
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            label={t(`attr.remark`)}
            onChange={(e) => setAttr({ ...attr, remark: e.target.value })}
            value={attr.remark}
            variant='standard'
            multiline
            inputProps={{
              maxLength: 200,
            }}
            fullWidth
          />
        </Grid>
      </Grid>
    );
  };

  const renderAdd = () => {
    return (
      <Dialog open={modalAdd} maxWidth='xs' keepMounted aria-describedby='dialog-add' fullWidth>
        <DialogTitle>
          {t(`element.add`)}
          <IconButton
            aria-label='close'
            onClick={() => setModalAdd(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>{renderInfo()}</MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={add}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='info' onClick={addConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderStepper = () => {
    const action = (key) => {
      switch (attr.status) {
        case 'edit':
          return key === 'request' || key === 'cancel';
        case 'request':
          return key === 'approve' || key === 'success' || key === 'cancel';
        case 'approve':
          return key === 'success' || key === 'cancel';
        default:
          return false;
      }
    };

    const stepLevel = (key) => {
      return (
        <Step sx={{ minWidth: 150 }}>
          <StepLabel StepIconComponent={CountingStepper}>
            {action(key) ? (
              <MDButton
                variant='gradient'
                color={stepperName[key].color}
                size='small'
                onClick={() => approve(key)}
              >
                <Icon>{stepperName[key].icon}</Icon> &nbsp; {stepperName[key].name}
              </MDButton>
            ) : stepper[key] === undefined ? (
              <MDTypography variant='subtitle2'>{stepperName[key].name}</MDTypography>
            ) : attr.status === key ? (
              <MDBox>
                <MDBadge
                  badgeContent={stepperName[key].name}
                  variant='contained'
                  color={stepperName[key].color}
                  size='md'
                  container
                />
                <MDTypography variant='subtitle2'>{stepper[key].emp_name}</MDTypography>
                <MDTypography variant='subtitle2'>
                  {Func.dateTimeDisplay(stepper[key].created_at)}
                </MDTypography>
              </MDBox>
            ) : (
              <MDBox>
                <MDTypography variant='h6'>{stepperName[key].name}</MDTypography>
                <MDTypography variant='subtitle2'>{stepper[key].emp_name}</MDTypography>
                <MDTypography variant='subtitle2'>
                  {Func.dateTimeDisplay(stepper[key].created_at)}
                </MDTypography>
              </MDBox>
            )}
          </StepLabel>
        </Step>
      );
    };

    const stepInt = () => {
      if (attr.status === 'request') return 2;
      if (attr.status === 'approve') return 3;
      if (attr.status === 'success') return 4;
      if (attr.status === 'cancel') return 9;

      return 0;
    };

    return loading ? null : (
      <MDBox className='stepper' mt={3} mb={1}>
        <Stepper activeStep={stepInt()} alternativeLabel>
          {stepLevel('edit')}
          {stepLevel('request')}
          {stepLevel('approve')}
          {stepLevel('success')}
          {stepLevel('cancel')}
        </Stepper>
      </MDBox>
    );
  };

  const renderInfoEdit = () => {
    const readOnly = attr.status !== 'edit';

    return (
      <MDBox className='card' p={2}>
        <Grid container>
          <Grid item xs={6}>
            <MDTypography variant='h5' mb={3}>
              ใบนับ
            </MDTypography>
          </Grid>
          <Grid item xs={6}>
            {attr.status === 'edit' ? (
              <MDBox display='flex' justifyContent='end' gap={1}>
                <MDButton variant='gradient' color='success' size='small' onClick={edit}>
                  <Icon>save</Icon>&nbsp;{t(`element.save`)}
                </MDButton>
              </MDBox>
            ) : null}
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDInput
              label={t(`attr.remark`)}
              onChange={(e) => setAttr({ ...attr, remark: e.target.value })}
              value={attr.remark}
              variant='standard'
              multiline
              inputProps={{
                maxLength: 200,
                readOnly: readOnly,
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderButton = () => {
    return (
      <MDBox display='flex' justifyContent='end' gap={1}>
        <MDButton variant='gradient' color='warning' onClick={copy}>
          <Icon>content_copy</Icon>&nbsp;{t(`element.copy`)}
        </MDButton>
      </MDBox>
    );
  };

  const renderNavigate = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container>
          <Grid item xs={6}>
            <NavLink to={`/${mod}`}>
              <MDButton variant='contained' color='dark'>
                <Icon>arrow_back</Icon>&nbsp;{t(`element.back`)}
              </MDButton>
            </NavLink>
          </Grid>
          {navigate.first === '' ? null : (
            <Grid item xs={6}>
              <MDBox display='flex' justifyContent='flex-end' gap={1}>
                <NavLink to={`/${mod}/${navigate.first}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.first === id}
                  >
                    <Icon>first_page</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.prev}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.prev === id}
                  >
                    <Icon>navigate_before</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.next}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.next === id}
                  >
                    <Icon>navigate_next</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.last}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.last === id}
                  >
                    <Icon>last_page</Icon>
                  </MDButton>
                </NavLink>
              </MDBox>
            </Grid>
          )}
        </Grid>
      </Card>
    );
  };

  const renderImage = () => {
    return (
      <Grid container spacing={2}>
        {image.map((item) => (
          <Grid item xs={12} sm={12} md={6} lg={3} key={item.id}>
            <MDBox className='card-img'>
              <CardHeader
                title={`Photo ID : #${item.id}`}
                subheader={Func.dateTimeDisplay(item.created_at)}
              />
              <CardMedia
                sx={{ height: 300, mt: 0 }}
                image={item.image}
                title={item.id}
                onClick={() => {
                  setPhoto(item);
                  setModalPhoto(true);
                }}
              />
              <CardContent>
                <MDTypography variant='body2'>สร้างโดย : {item.user_name}</MDTypography>
              </CardContent>
            </MDBox>
          </Grid>
        ))}
      </Grid>
    );
  };

  const renderRequest = () => {
    const countingAll = (inp) => {
      if (inp === 'Y') return 'นับทุกรายการ';
      return 'นับบางรายการ';
    };

    const approveAuto = (inp) => {
      if (inp === 'Y') return 'ปรับปริมาณอัตโนมัติ';
      return 'รออนุมัติส่วนต่าง';
    };

    return (
      <MDBox className='card' p={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDTypography variant='h5'>ใบสั่งนับ</MDTypography>
          </Grid>
          <Grid item xs={12} md={6}>
            <MDInput
              label='คลังที่ตรวจนับ'
              value={request.warehouse_name}
              variant='standard'
              multiline
              inputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <MDInput
              label='รอบการตรวจนับ'
              value={request.time_name}
              variant='standard'
              multiline
              inputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <MDInput
              label='วันเริ่มนับ'
              value={Func.dateDisplay(request.date_start)}
              variant='standard'
              multiline
              inputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <MDInput
              label='วันกำหนดเสร็จ'
              value={Func.dateDisplay(request.date_stop)}
              variant='standard'
              multiline
              inputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <MDInput
              label='ประเภทการนับ'
              value={countingAll(request.counting_all)}
              variant='standard'
              multiline
              inputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <MDInput
              label='การตรวจสอบ'
              value={approveAuto(request.approve_auto)}
              variant='standard'
              multiline
              inputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label={t(`attr.remark`)}
              value={request.remark}
              variant='standard'
              multiline
              inputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderOpen = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {renderNavigate()}
          </Grid>
          <Grid item xs={12}>
            {renderStepper()}
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox sx={{ width: '100%' }}>
                <MDBox>
                  <Tabs
                    value={tab}
                    onChange={(e, v) => setTab(v)}
                    aria-label='tabs-addedit'
                    sx={{ overflowX: 'scroll' }}
                  >
                    <Tab label='ใบจัดสินค้า' />
                    {image.length > 0 ? <Tab label='ภาพการนับ' /> : null}
                  </Tabs>
                </MDBox>
                <TabPanel value={tab} index={0}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <MDTypography variant='h3'>#{attr.code}</MDTypography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      {renderButton()}
                    </Grid>
                    <Grid item xs={4}>
                      {renderInfoEdit()}
                    </Grid>
                    <Grid item xs={8}>
                      {renderRequest()}
                    </Grid>
                    <Grid item xs={12}>
                      <CountingList parent={attr} ref={listRef} />
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value={tab} index={1}>
                  {renderImage()}
                </TabPanel>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderPhoto = () => {
    return (
      <Dialog
        open={modalPhoto}
        maxWidth='md'
        keepMounted
        aria-describedby='dialog-image'
        fullWidth
        onClose={() => setModalPhoto(false)}
      >
        <DialogTitle>
          {Func.dateTimeDisplay(photo.created_at)}
          <IconButton
            aria-label='close'
            onClick={() => setModalPhoto(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox
            component='img'
            src={photo.image}
            alt={photo.name}
            borderRadius='lg'
            shadow='sm'
            width='100%'
            position='relative'
          />
        </DialogContent>
      </Dialog>
    );
  };

  const renderPage = () => {
    if (id === undefined) return renderList();
    return renderOpen();
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, [id]);

  return (
    <DashboardLayout>
      <Navbar route={[t(`menu.warehouse`), t(`menu.counting`)]} />
      {renderPage()}
      {renderAdd()}
      {renderPhoto()}
      <Footer />
      {renderLoading()}
      {notify}
    </DashboardLayout>
  );
}

export default Counting;
